import './EmailResetPage.scss';

import { createContext, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import EmailResetFinish from './EmailResetSteps/EmailResetFinish';
import EmailResetStart from './EmailResetSteps/EmailResetStart';
import EmailResetVerify from './EmailResetSteps/EmailResetVerify';

export const RESET_EMAIL_STEPS = {
  START: 1,
  VERIFY: 2,
  FINISH: 3
}

/**
 * @typedef {Object} EmailResetContext
 * 
 * @property {number} step
 * @property {React.Dispatch<React.SetStateAction<number>>} setStep
 */

/** @type {React.Context<EmailResetContext>} */
const Context = createContext({});

export function useEmailResetContext() {
  return useContext(Context);
}

export default function EmailResetPage() {
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(RESET_EMAIL_STEPS.START);

  useEffect(() => {
    if (step === RESET_EMAIL_STEPS.START && searchParams.has('em') && searchParams.has('cd')) {
      setStep(RESET_EMAIL_STEPS.FINISH);
    }
  }, [searchParams, step, setStep]);

  useEffect(() => {
    document.title = 'Reset Email - Papaya';
  }, []);

  return (
    <Context.Provider value={{ step, setStep }}>
      { step === RESET_EMAIL_STEPS.START && (
        <EmailResetStart />
      ) }
      { step === RESET_EMAIL_STEPS.VERIFY && (
        <EmailResetVerify />
      ) }
      { step === RESET_EMAIL_STEPS.FINISH && (
        <EmailResetFinish />
      ) }
    </Context.Provider>
  );
}
